module.exports = __webpack_public_path__ + "assets/4db8f5c22e24ef93045d272eb52d6af4.png";